import { prepHandleEvent } from "./prepHandleEvent";
import { enumKeySource } from "../constants";

export function handleMobileKeyPress(event) {
  var canvasElement = document.getElementById("basecanvas");
  var myApp = prepHandleEvent(canvasElement, false, null, null);
  if (myApp == null) {
    return;
  }
  var handled = myApp.HandleKeyboard(event, enumKeySource.keyPress);

  if (handled) {
    // Prevent tab key from being handled by browser
    event.preventDefault();
  }
}
